import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import HomePage from './components/HomePage';
import EditorPage from './components/EditorPage';

function App() {
  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#343541',
            color: '#ececf1',
            border: '1px solid #40414f',
          },
          success: {
            iconTheme: {
              primary: '#22c55e',
              secondary: '#343541',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#343541',
            },
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="editor/:sessionId?" element={<EditorPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
